import auth from "../../../middleware/auth.js";
import shortcuts from "../../../middleware/shortcuts.js";
import {appHelper} from "../../../utils/helpers/appHelper.js";
import {routeHelper} from "../../../utils/helpers/routeHelper.js";

/**
 * Created by Andriyanto.
 * E-Mail Address: 4lenour@gmail.com
 * Date: 17/12/2024
 */
export const AmsAppEmployee = [
    {
        path: appHelper.path.amsApp + '/employee',
        name:'amsApHrEmployee',
        component: routeHelper.asyncComponentWithLoader(() => import('../../hrapp/views/employee/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        path: appHelper.path.amsApp + '/employee/blood',
        name: 'amsAppHrBlood',
        component: routeHelper.asyncComponentWithLoader(() => import('../../hrapp/views/blood/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        path: appHelper.path.amsApp + '/employee/religion',
        name: 'amsAppHrReligion',
        component: routeHelper.asyncComponentWithLoader(() => import('../../hrapp/views/blood/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        path: appHelper.path.amsApp + '/employee/marital',
        name: 'amsAppHrMarital',
        component: routeHelper.asyncComponentWithLoader(() => import('../../hrapp/views/blood/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        path: appHelper.path.amsApp + '/employee/education',
        name: 'amsAppHrEducation',
        component: routeHelper.asyncComponentWithLoader(() => import('../../hrapp/views/blood/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        path: appHelper.path.amsApp + '/employee/status',
        name: 'amsAppHrStatus',
        component: routeHelper.asyncComponentWithLoader(() => import('../../hrapp/views/status/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        path: appHelper.path.amsApp + '/employee/grade',
        name: 'amsAppHrGrade',
        component: routeHelper.asyncComponentWithLoader(() => import('../../hrapp/views/grade/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        path: appHelper.path.amsApp + '/assignment-plan',
        name: 'amsAppAssignmentPlan',
        component: routeHelper.asyncComponentWithLoader(() => import('../../amsapp/views/assignment-plan/index.vue')),
        meta: { middleware: [auth, shortcuts] }
    },
    {
        name: 'amsAppAttendanceLocation',
        path: appHelper.path.amsApp + '/location/attendance',
        component: routeHelper.asyncComponentWithLoader(() => import('../../cms/views/location/location.vue')),
        meta: { middleware: [auth, shortcuts], termParent: false }
    },
    {
        name: 'amsAppCmsTermNewsUpdate',
        path: appHelper.path.amsApp + '/term-category/news-updates',
        component: routeHelper.asyncComponentWithLoader(() => import('../../cms/views/term/index.vue')),
        meta: { middleware: [auth, shortcuts], termParent: true }
    },
    {
        name: 'amsAppCmsTagNewsUpdate',
        path: appHelper.path.amsApp + '/term-tag/news-updates',
        component: routeHelper.asyncComponentWithLoader(() => import('../../cms/views/term/index.vue')),
        meta: { middleware: [auth, shortcuts], termParent: false }
    },
    {
        name: 'amsAppPostNewsUpdate',
        path: appHelper.path.amsApp + '/cms-post/news-updates',
        component: routeHelper.asyncComponentWithLoader(() => import('../../cms/views/post/index.vue')),
        meta: { middleware: [auth, shortcuts], termParent: false }
    }
];
